export default {
    indexTermOptions:     { method: 'get',    url: 'term_options' },
    createTermOption:     { method: 'post',   url: 'term_options'},
    updateTermOption:     { method: 'put',    url: 'term_options/{id}'},
    destroyTermOption:    { method: 'delete', url: 'term_options/{id}'},
}
